<!-- ngRepeat: subAnswer in question.answers.subAnswers track by $index -->
<div
    *ngIf="qsForm"
    [formGroup]="qsForm"
    class="complex-question__content ng-scope ng-isolate-scope"
    data-ng-repeat="subAnswer in question.answers.subAnswers track by $index"
    data-sub-answer-form=""
    data-question="question"
    data-sub-answer="subAnswer"
    data-sub-answer-index="$index"
    data-on-remove-sub-answer="removeSubAnswer($index)"
>
    <article class="sub-answer-form">
        <section>
            <div class="sub-answer grid-container ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-real-date ng-dirty ng-valid-parse" data-ng-form="subform">
                <div class="sub-answer__questions grid-10 grid-mobile-4">
                    <ng-template ngFor let-sousQuestion [ngForOf]="questionQuestionnaireSante.listeSousQuestions">
                        <app-auto-complete-component
                            *ngIf="['medicament', 'analyse', 'chaine', 'maladie'].includes(sousQuestion.type)"
                            [subquestion]="sousQuestion"
                            [qsForm]="qsForm"
                            [controlId]="controlId"
                            [controlsEnable]="controlsEnable"
                            class="sub-answer__group ng-isolate-scope"
                            [ngClass]="'sub-answer__group--' + gridSize(sousQuestion)"
                            [charCounter]="charCounter"
                            [maxCharCounter]="maxCharCounter"
                            (valueChanged)="emitValuesChanged()"
                        >
                        </app-auto-complete-component>
                        <app-taux-component
                            *ngIf="sousQuestion.type === 'taux'"
                            [subquestion]="sousQuestion"
                            [qsForm]="qsForm"
                            [controlId]="controlId"
                            [controlsEnable]="controlsEnable"
                            class="sub-answer__group ng-isolate-scope"
                            [ngClass]="'sub-answer__group--' + gridSize(sousQuestion)"
                        >
                        </app-taux-component>
                        <app-date-passe-exacte-component
                            *ngIf="sousQuestion.type === 'date_passe_exacte'"
                            [subquestion]="sousQuestion"
                            [qsForm]="qsForm"
                            [controlId]="controlId"
                            [controlsEnable]="controlsEnable"
                            class="sub-answer__group ng-isolate-scope"
                            [ngClass]="'sub-answer__group--' + gridSize(sousQuestion)"
                        >
                        </app-date-passe-exacte-component>
                        <app-date-component
                            *ngIf="['date_passe', 'date_futur'].includes(sousQuestion.type)"
                            [subquestion]="sousQuestion"
                            [qsForm]="qsForm"
                            [controlId]="controlId"
                            [controlsEnable]="controlsEnable"
                            class="sub-answer__group ng-isolate-scope"
                            [ngClass]="'sub-answer__group--' + gridSize(sousQuestion)"
                        >
                        </app-date-component>
                        <app-duree-component
                            *ngIf="sousQuestion.type === 'duree'"
                            [subquestion]="sousQuestion"
                            [qsForm]="qsForm"
                            [controlId]="controlId"
                            [controlsEnable]="controlsEnable"
                            class="sub-answer__group ng-isolate-scope"
                            [ngClass]="'sub-answer__group--' + gridSize(sousQuestion)"
                        >
                        </app-duree-component>
                    </ng-template>
                </div>
                <div class="grid-2 grid-mobile-4 sub-answer__remove">
                    <span
                        [id]="'remove-motif-' + questionQuestionnaireSante.id + '-' + controlId"
                        class="sub-answer__button ng-binding"
                        (click)="removeMotif()"
                        data-tag-commander=""
                        [appTagCommander]="'tagCo..question.removesubanswer.button'"
                    >
                        {{ 'medicalworkflow.question.delete' | i18n }}&nbsp;<span class="icon--delete"></span>
                    </span>
                </div>
            </div>
        </section>
    </article>
</div>
<!-- end ngRepeat: subAnswer in question.answers.subAnswers track by $index -->
